import * as React from 'react';
import { z } from 'zod';

const messageObjectSchema = z.record(z.unknown());

const iframeNamedMessageSchema = z.object({ name: z.string() });
const iframeGcmEventMessageSchema = z.object({ gcmevent: z.string() });

const betgliderWidgetMessageSchema = z.object({
    source: z.literal('betglider-widget'),
    type: z.string(),
});

const gprgUserActionMessageSchema = z.object({
    rgMessage: z.literal('gprg_UserAction'),
    payload: z.object({ action: z.string() }),
});

interface PropsType {
    className?: string;
    src?: string;
    // target?: string,
    title?: string;
    onMessage?: (data: string) => void;
    allowFullScreen?: true;
    dataTest?: string;
}

export class Iframe extends React.Component<PropsType> {
    public ref: HTMLIFrameElement | null = null;

    private onMessage = (event: MessageEvent): void => {
        if (this.ref !== null && this.props.onMessage !== undefined) {
            if (this.ref.contentWindow === event.source) {
                if (typeof event.data === 'string') {
                    this.props.onMessage(event.data);
                    return;
                }

                const objectMessage = messageObjectSchema.safeParse(event.data);
                if (!objectMessage.success) {
                    return;
                }
                const data = objectMessage.data;

                const namedMessage = iframeNamedMessageSchema.safeParse(data);
                if (namedMessage.success) {
                    this.props.onMessage(namedMessage.data.name);
                } else {
                    const gcmEventMessage = iframeGcmEventMessageSchema.safeParse(data);
                    if (gcmEventMessage.success) {
                        this.props.onMessage(gcmEventMessage.data.gcmevent);
                    }
                }

                const betgliderMessage = betgliderWidgetMessageSchema.safeParse(data);
                if (betgliderMessage.success) {
                    this.props.onMessage(betgliderMessage.data.type);
                }

                if (event.data.eventType !== undefined) {
                    switch (event.data.eventType) {
                        case 'onCloseIframeSuccess':
                            this.props.onMessage('success');
                            break;
                        case 'onCloseIframeFail':
                            this.props.onMessage('serverIssue');
                            break;
                    }
                }

                if (event.data.rgMessage === 'gprg_Listening') {
                    this.props.onMessage('gprg_Listening');
                }

                const gprgUserAction = gprgUserActionMessageSchema.safeParse(data);
                if (gprgUserAction.success) {
                    this.props.onMessage(`gprg_UserAction_${gprgUserAction.data.payload.action}`);
                }
            }
        }
    };

    public componentDidMount(): void {
        window.addEventListener('message', this.onMessage);
    }

    public componentWillUnmount(): void {
        window.removeEventListener('message', this.onMessage);
    }

    private setRef = (ref: HTMLIFrameElement | null): void => {
        this.ref = ref;
    };

    public render(): JSX.Element {
        const { className, src, title, allowFullScreen, dataTest } = this.props;

        return (
            <iframe
                className={className}
                src={src}
                ref={this.setRef}
                title={title}
                allowFullScreen={allowFullScreen}
                data-test={dataTest}
            />
        );
    }
}
